// extracted by mini-css-extract-plugin
export default {"title":"home_title__cojxH","gameList":"home_gameList__55lIc","noResults":"home_noResults__n9RZt"};